import {enumTypes, getEnumLabel, getEnumValue} from '../../../utils/enumHelper';

export const ResultStatus = {
  PASS: 'pass',
  FAIL: 'fail',
  PARTIAL_PASS: 'partial-pass',
  PARTIAL_FAIL: 'partial-fail',  //update version
}

export function getCoCResultOptions() {
  return [
    {value: getEnumValue(enumTypes.COC_TEST_RESULT)('PASS'), label: getEnumLabel(enumTypes.COC_TEST_RESULT)('PASS')},
    {value: getEnumValue(enumTypes.COC_TEST_RESULT)('FAIL'), label: getEnumLabel(enumTypes.COC_TEST_RESULT)('FAIL')},
  ]
}

const validMimeTypes = {
  PDF: ['application/pdf'],
  GRAPH: ['application/pdf'],
  CSV: ['text/csv'],
  EXCEL: [
          'application/vnd.ms-excel', // .xls
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
         ],
};

const validExtensions = {
  PDF: ['.pdf'],
  GRAPH: ['.pdf'],
  CSV: ['.csv'],
  EXCEL: ['.xls', '.xlsx'],
};

const allValidExtensions = ['.pdf', '.doc', '.docx', '.txt', '.xls', '.xlsx', '.csv','.jpg', '.jpeg', '.gif', '.png', '.bmp'];
const allValidMimeTypes = [
  'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain ', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv', 'image/jpeg', 'image/gif', 'image/png', ' image/bmp'
]

//Note: returns the file extension including the dot (e.g., .pdf)
const getFileExtension = (fileName = '') => {
  const lastDotIndex = fileName.lastIndexOf('.');
  if (lastDotIndex < 0 || lastDotIndex === fileName.length - 1) {
    return '';
  }
  return fileName.slice(lastDotIndex).toLowerCase();
}

export const validateFileType = (file, type) => {
  if (!file || !type || (!file.type && !file.name)) {
    return false;
  }

  const mimeType = file.type?.toLowerCase();
  const extension = getFileExtension(file.name);

  // const allowedMimeTypes = validMimeTypes[type] || [];
  // const allowedExtensions = validExtensions[type] || [];

  // const isMimeValid = mimeType && allowedMimeTypes.includes(mimeType);
  // const isExtensionValid = extension && allowedExtensions.includes(extension);
  const isMimeValid = mimeType && allValidMimeTypes.includes(mimeType);
  const isExtensionValid = extension && allValidExtensions.includes(extension);

  return isMimeValid || isExtensionValid;
};

export function getCoCAttachmentAcceptTypes(type) {
  return validExtensions[type]?.join();
}

export function getCoCAttachmentAcceptGenericTypes() {
  return ['.pdf', '.doc', '.docx', '.txt', '.xls', '.xlsx',  '.csv','.jpg', '.jpeg', '.gif', '.png', '.bmp']
}

export function getCategoryByFileType(fileType) {
  switch (fileType) {
    case getEnumValue(enumTypes.QPL_ATTACHMENT_TYPE)('PDF'):
      return 'COC_PDF';
    case getEnumValue(enumTypes.QPL_ATTACHMENT_TYPE)('GRAPH'):
      return 'COC_GRAPH';
    case getEnumValue(enumTypes.QPL_ATTACHMENT_TYPE)('CSV'):
      return 'COC_CSV';
    case getEnumValue(enumTypes.QPL_ATTACHMENT_TYPE)('EXCEL'):
      return 'COC_EXCEL';
    case 'GENERIC':
      return 'COC_GENERIC';
  }
  console.error('getCategoryByFileType(): unknown file type ' + fileType);
  return '';
}

export function getFileTypeByCategory(category) {
  switch (category) {
    case 'COC_PDF':
      return getEnumValue(enumTypes.QPL_ATTACHMENT_TYPE)('PDF');
    case 'COC_GRAPH':
      return getEnumValue(enumTypes.QPL_ATTACHMENT_TYPE)('GRAPH');
    case 'COC_CSV':
      return getEnumValue(enumTypes.QPL_ATTACHMENT_TYPE)('CSV');
    case 'COC_EXCEL':
      return getEnumValue(enumTypes.QPL_ATTACHMENT_TYPE)('EXCEL');
    case 'COC_GENERIC':
      return 'GENERIC';
  }
  console.error('getCategoryByFileType(): unknown file type ' + category);
  return '';
}
